/* Sourcing page: play the hero clip only while it's on screen (defer its ~9 MB fetch
   and pause off-screen). The producer cards are static now (lean design), so there's
   no gallery behaviour here. */
(function () {
  'use strict';
  function init() {
    // Play the sourcing clip (muted loop) only while it's on screen, and let
    // preload="none" defer the ~9 MB fetch until the first play. Skipped entirely
    // under prefers-reduced-motion — the poster + native controls let the user
    // start it manually instead.
    var video = document.querySelector('[data-gb-video]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (video && !reduceMotion && 'IntersectionObserver' in window) {
      // Resume on scroll-in ONLY if we (the observer) paused it on the way out — never
      // over a pause the user made with the controls. Starts true so it plays on first view.
      var pausedByObserver = true;
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (pausedByObserver) { pausedByObserver = false; video.play().catch(function () {}); }
            } else if (!video.paused) {
              pausedByObserver = true;
              video.pause();
            }
          });
        },
        { threshold: 0.35 }
      ).observe(video);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
